import type { ReactNode } from "react";

export const primaryBtnClass =
  "inline-flex h-14 items-center justify-center rounded-[8px] bg-purple-03 px-7 text-body font-bold text-white transition-colors hover:bg-purple-04";
export const secondaryBtnClass =
  "inline-flex h-14 items-center justify-center rounded-[8px] border border-purple-03 px-7 text-body font-bold text-purple-05 transition-colors hover:bg-purple-03 hover:text-white";

// Shared branded layout for the 404 / error pages.
export function ErrorView({
  eyebrow,
  title,
  message,
  children,
  links,
}: {
  eyebrow: string;
  title: string;
  message: string;
  children: ReactNode;
  links?: ReactNode;
}) {
  return (
    <section className="bg-dusk-01">
      <div className="mx-auto flex min-h-[60vh] w-full max-w-[640px] flex-col items-center justify-center px-[clamp(1.25rem,4vw,2.5rem)] py-20 text-center lg:py-28">
        <p className="text-h6 font-bold tracking-[0.08em] text-purple-03 uppercase">
          {eyebrow}
        </p>
        <h1 className="mt-4 text-h3 leading-[1.08] font-bold text-purple-05 lg:text-h2">
          {title}
        </h1>
        <p className="mt-4 max-w-[480px] text-body leading-[1.6] text-black/65">
          {message}
        </p>
        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          {children}
        </div>
        {links && (
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-button font-semibold text-purple-04">
            {links}
          </div>
        )}
      </div>
    </section>
  );
}
